module.exports = __webpack_public_path__ + "static/img/logo-sharp.36b3aa5.png";